'use client';

import { createContext, useContext, useState } from 'react';

export const PaginatorContext = createContext(null);

const defaultItems = [];

export function PaginatorProvider({ children, items = defaultItems, defaultIndex = 0, defaultIndexRange = undefined }) {
  const initialActiveIndex = defaultIndexRange !== undefined ? defaultIndexRange : defaultIndex;
  const [index, setIndexValue] = useState(defaultIndex);
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);
  const [nextIndex, setNextIndex] = useState(defaultIndex);
  const [clickDirection, setScrollDirection] = useState(null);

  const setIndex = (newIndex) => {
    if (newIndex >= 0 && newIndex < items.length) {
      setIndexValue(newIndex);
    }
  };

  return (
    <PaginatorContext.Provider
      value={{
        items,
        index,
        activeIndex,
        setIndex,
        setActiveIndex,
        nextIndex,
        setNextIndex,
        clickDirection,
        setScrollDirection
      }}
    >
      {children}
    </PaginatorContext.Provider>
  );
}

export function usePaginator() {
  const context = useContext(PaginatorContext);
  if (!context) {
    throw new Error('usePaginator must be used within a PaginatorProvider');
  }
  return context;
}
